module.exports = __webpack_public_path__ + "img/ANTENNA TWIRL RED.8a022d5.svg";